export const STATUS_META = {
  actief: {
    badge: "bg-emerald-100 text-emerald-700 border-emerald-200",
    cta: "Openen",
  },
  concept: {
    badge: "bg-amber-100 text-amber-700 border-amber-200",
    cta: "Instellen",
  },
  niet_ingesteld: {
    badge: "bg-slate-200 text-slate-700 border-slate-300",
    cta: "Instellen",
  },
};

export function getStatusLabel(status) {
  if (status === "actief") return "Actief";
  if (status === "concept") return "Concept";
  return "Niet ingericht";
}

function hasAnyTextValue(values = []) {
  return values.some((value) => String(value || "").trim().length > 0);
}

export function resolveWorkflowStatus(workflowKey, settings) {
  const modules = settings?.modules || {};
  const workorderTypes = Array.isArray(settings?.workorderTypes)
    ? settings.workorderTypes
    : [];

  switch (workflowKey) {
    case "workflow_workorder":
      return workorderTypes.length > 0 ? "actief" : "concept";
    case "workflow_calculatie":
      return "concept";
    case "workflow_administratie":
      return settings?.eInvoicing?.enabled ? "actief" : "concept";
    case "workflow_inkoop":
      return settings?.procurement ? "actief" : "concept";
    case "workflow_uren":
      return settings?.completionRequirements?.requireHours ? "actief" : "concept";
    case "workflow_customer_portal":
      return modules?.customerPortalEnabled ? "actief" : "niet_ingesteld";
    case "workflow_kam":
      return modules?.fireSafetyLogbook?.enabled ? "actief" : "concept";
    case "workflow_compliance":
      return modules?.fireSafetyLogbook?.enabled ? "actief" : "niet_ingesteld";
    default:
      return "concept";
  }
}

export function resolveModuleStatus(moduleKey, settings) {
  const modules = settings?.modules || {};
  switch (moduleKey) {
    case "module_fire_safety_logbook":
      return modules?.fireSafetyLogbook?.enabled ? "actief" : "niet_ingesteld";
    case "module_customer_portal":
      return modules?.customerPortalEnabled ? "actief" : "niet_ingesteld";
    case "module_supplier_templates":
      return modules?.supplierTemplateLibraryEnabled ? "actief" : "concept";
    case "module_zzp_mode":
      return modules?.zzpMode ? "actief" : "concept";
    default:
      return "concept";
  }
}

export function resolveIntegrationStatus(integrationKey, settings) {
  const integrations = settings?.integrations || {};
  const moneybird = integrations?.moneybird || {};
  const tu = integrations?.tu || {};
  const mail = integrations?.mail || {};
  const workorderTypes = Array.isArray(settings?.workorderTypes)
    ? settings.workorderTypes
    : [];
  const branding = settings?.branding || {};

  switch (integrationKey) {
    case "integration_moneybird":
      if (moneybird.connected) return "actief";
      if (moneybird.enabled) return "concept";
      return "niet_ingesteld";
    case "integration_tu":
      if (tu.connected) return "actief";
      if (tu.enabled) return "concept";
      return "niet_ingesteld";
    case "integration_mail": {
      const configured = hasAnyTextValue([
        mail?.fromAddress,
        mail?.smtpHost,
        mail?.provider,
      ]);
      return configured ? "actief" : "concept";
    }
    case "integration_pdf_templates":
      return workorderTypes.some((type) => type?.generateWorkReport !== false)
        ? "actief"
        : "concept";
    case "integration_branding": {
      const configured = hasAnyTextValue([
        branding?.companyName,
        branding?.logoUrl,
        branding?.primaryColor,
      ]);
      return configured ? "actief" : "niet_ingesteld";
    }
    default:
      return "concept";
  }
}

export function resolveHubTileStatus(key, settings, insights = {}) {
  const modules = settings?.modules || {};
  const usersCount = Number(insights?.usersCount || 0);
  const roleCount = Number(insights?.roleCount || 0);

  switch (key) {
    case "tenant_status":
      return settings ? "actief" : "concept";
    case "users":
      return usersCount > 0 ? "actief" : "concept";
    case "roles":
      return roleCount > 0 ? "actief" : "concept";
    case "settings":
      return settings ? "actief" : "concept";
    case "modules": {
      const enabledCount = [
        Boolean(modules?.fireSafetyLogbook?.enabled),
        Boolean(modules?.customerPortalEnabled),
        Boolean(modules?.supplierTemplateLibraryEnabled),
        Boolean(modules?.zzpMode),
      ].filter(Boolean).length;
      if (enabledCount >= 2) return "actief";
      if (enabledCount === 1) return "concept";
      return "niet_ingesteld";
    }
    case "workflow_workorder":
    case "workflow_calculatie":
    case "workflow_administratie":
    case "workflow_inkoop":
    case "workflow_uren":
    case "workflow_customer_portal":
    case "workflow_kam":
    case "workflow_compliance":
      return resolveWorkflowStatus(key, settings);
    case "integration_moneybird":
    case "integration_tu":
    case "integration_mail":
      return resolveIntegrationStatus(key, settings);
    case "pdf_templates":
      return resolveIntegrationStatus("integration_pdf_templates", settings);
    case "branding":
      return resolveIntegrationStatus("integration_branding", settings);
    default:
      return "concept";
  }
}
